var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorldcupTicket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-bill-wave-alt",
    clipPath: "url(#clip0_0_28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000005570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4701 1.48914C16.3792 1.04426 15.2873 0.875 14.1961 0.875C10.7319 0.874727 7.26806 2.57961 3.80391 2.57961C2.93513 2.57961 2.06691 2.47242 1.19813 2.20445C1.10053 2.17438 1.00266 2.16016 0.907031 2.16016C0.423 2.16016 0 2.52437 0 3.02996V11.705C0 12.0504 0.203344 12.3777 0.529875 12.5106C1.62084 12.9557 2.71266 13.125 3.80391 13.125C7.26806 13.125 10.7322 11.4201 14.1964 11.4201C15.0652 11.4201 15.9334 11.5273 16.8022 11.7953C16.8998 11.8254 16.9976 11.8396 17.0933 11.8396C17.5773 11.8396 18.0003 11.4754 18.0003 10.9698V2.29496C18 1.94934 17.7967 1.6223 17.4701 1.48914Z",
    fill: "var(--fill-0, #919191)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 20 (Stroke)",
    d: "M13.5 1.55566C13.4999 1.83176 13.2761 2.05566 13 2.05566C12.7239 2.05566 12.5001 1.83176 12.5 1.55566L12.5 1C12.5 0.723858 12.7239 0.5 13 0.5C13.2761 0.5 13.5 0.723858 13.5 1L13.5 1.55566ZM13.5 4.88867C13.5 5.16481 13.2761 5.38867 13 5.38867C12.7239 5.38867 12.5 5.16481 12.5 4.88867L12.5 3.77734C12.5002 3.5014 12.724 3.27734 13 3.27734C13.276 3.27734 13.4998 3.5014 13.5 3.77734L13.5 4.88867ZM13.5 8.22266C13.4998 8.4986 13.276 8.72266 13 8.72266C12.724 8.72266 12.5002 8.4986 12.5 8.22266L12.5 7.11133C12.5 6.83519 12.7239 6.61133 13 6.61133C13.2761 6.61133 13.5 6.83519 13.5 7.11133L13.5 8.22266ZM13.5 11C13.5 11.2761 13.2761 11.5 13 11.5C12.7239 11.5 12.5 11.2761 12.5 11L12.5 10.4443C12.5001 10.1682 12.7239 9.94434 13 9.94434C13.2761 9.94434 13.4999 10.1682 13.5 10.4443L13.5 11Z",
    fill: "var(--fill-0, white)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldcupTicket);
export default __webpack_public_path__ + "static/media/worldcup-ticket.00bf0de2c62f5058f94fdaf91347d772.svg";
export { ForwardRef as ReactComponent };